module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasPhotosetData) ? _c('div', [_c('header', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "page-header-media slide-loadable",
    class: {
      'loaded': _vm.imageLoaded
    },
    style: ({
      backgroundImage: 'url(' + _vm.photoSource + ')'
    }),
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.photosetData.title._content))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.photosetData.description._content))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.photos), function(photo, index) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-4",
      attrs: {
        "data-index": index > 0
      }
    }, [_c('div', {
      staticClass: "slide slide-square slide-link",
      on: {
        "click": function($event) {
          _vm.handlePhotoClick(index)
        }
      }
    }, [_c('photo', {
      attrs: {
        "id": photo.id,
        "size": 1
      }
    }), _vm._v(" "), (_vm.activePhoto == photo.id) ? _c('photo-full-screen', {
      attrs: {
        "id": photo.id,
        "next": index + 1 < _vm.photos.length ? index + 1 : null,
        "previous": index > 0 ? index - 1 : null,
        "include-meta": true
      }
    }) : _vm._e()], 1)])
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69a8272c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/routes/Photoset.vue
// module id = 124
// module chunks = 2